const ProjectData = [
  {
    name: "FitnessCenter",
    image: "gymapp.png",
    gif: "gymapp.gif",
    url: "https://unartcs.github.io/gym-react-app-project/",
    description:
      "A fitness center website demo with classes, schedule, gallery and more. Made with React.",
    tech: ["React", "Vanilla CSS"],
    source_url: "https://github.com/unartcs/gym-react-app-project",
    playing: false,
  },
  {
    name: "Recipe App",
    image: "recipeapp.png",
    gif: "recipeapp.png",
    url: "https://unartcs.github.io/recipe-app/",
    description:
      "A recipe app connected to an API where you could search for recipes of your likings. Made with React and API",
    tech: ["React", "Styled CSS", "Recipe API"],
    source_url: "https://github.com/unartcs/recipe-app",
  },

  {
    name: "Female Upcomers (WIP)",
    image: "femaleupcomersapp.png",
    gif: "femaleupcomersapp.png",
    url: "https://female-upcomers-react.onrender.com/",
    description:
      "Female upcomers is a freelance project I made for a Aarhus university female organization",
    tech: ["React", "Vanilla CSS", "Instagram API", "Spotify API"],
    //source_url: '',
  },
  {
    name: "Todo list",
    image: "todoapp.png",
    gif: "todoapp.png",
    url: "https://unartcs.github.io/react-todo-app-project/",
    description:
      "A small app to track task list made with React and Local Storage",
    tech: ["React", "Vanilla CSS", "Local Storage"],
    source_url: "https://github.com/unartcs/react-todo-app-project",
  },
  {
    name: "Weather App",
    image: "weatherapp.png",
    gif: "weatherapp.png",
    url: "https://unartcs.github.io/weather-app/",
    description:
      "A mini weather app to check the weather in certain cities/countries. Made with weather API",
    tech: ["JavaScript", "Vanilla CSS", "Weather API"],
    source_url: "https://github.com/unartcs/weather-app",
  },

  {
    name: "Car Rental4U",
    image: "carapp.png",
    gif: "carapp.png",
    url: "https://unartcs.github.io/car-rental-project/",
    description: "A car rental landing page made with React.",
    tech: ["React", "Vanilla CSS"],
    source_url: "https://github.com/unartcs/car-rental-project",
  },
];
export default ProjectData;
